/* eslint-disable no-redeclare */
import configs from '../../constants/configs';
import { request } from '../request';
import { ERR_IMAGE_UPLOAD_INVALID_FILE, ERR_IMAGE_UPLOAD_UPLOAD } from '../../constants/Errors';

interface IImageUrl {
    imageUrl: string;
    imageSuffix?: string;
}

interface IImageContent {
    imageSuffix?: string;
    imageData: string;
}

/**
 * Uploads the image to amazon s3
 * @param {object} image - Uploaded Image
 * @param {boolean} isUrl - Whether the source of the image is a URL or is being uploaded from the user's computer
 */
function uploadImage(image: IImageUrl, isUrl: true): Promise<string>;
function uploadImage(image: IImageContent): Promise<string>;
function uploadImage(image: any, isUrl?: boolean): Promise<string> {
    const { imageUrl, imageSuffix, imageData } = image;
    return new Promise((resolve, reject) => {
        (async () => {
            if (isUrl) {
                try {
                    const data = await request.custom(configs.uploadImageByLink, {
                        method: 'POST',
                        body: JSON.stringify({
                            imageUrl,
                            imageSuffix,
                        }),
                        headers: {
                            Accept: '*/*',
                            'Content-Type': 'application/json',
                        },
                        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                    });
                    const { link } = data;
                    resolve(link.replace(/bt-templates.s3.us-west-2.amazonaws.com/g, 'storage-images.bananatag.com'));
                } catch (err) {
                    reject(err);
                }
            } else {
                try {
                    const regex = /^data:image\/(png|jpg|jpeg|gif);base64,/;
                    const matches = image.imageData.match(regex);
                    if (!matches) {
                        return reject(new Error(ERR_IMAGE_UPLOAD_INVALID_FILE));
                    }
                    const imageMimetype = matches[1];
                    const base64ImageContent = imageData.replace(regex, '');

                    const data = await request.custom(configs.uploadImageByContent, {
                        method: 'POST',
                        body: JSON.stringify({
                            imageData: base64ImageContent,
                            imageSuffix: imageMimetype,
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    const { link } = data;
                    if (!link) {
                        // eslint-disable-next-line no-console
                        console.error(data.error);
                        reject(
                            data.error && data.error.customMessage ? data.error : new Error(ERR_IMAGE_UPLOAD_UPLOAD)
                        );
                        return;
                    }

                    resolve(link.replace(/bt-templates.s3.us-west-2.amazonaws.com/g, 'storage-images.bananatag.com'));
                } catch (err: any) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    reject(err.customMessage ? err : new Error(ERR_IMAGE_UPLOAD_UPLOAD));
                }
            }
        })();
    });
}

export default uploadImage;
